import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '../services/auth.service';
import { UtilitaService } from '../services/utilita.service';
import { SettoreScientificoDettaglioComponent } from './settore-scientifico-dettaglio/settore-scientifico-dettaglio.component';

@Component({
  selector: 'app-settore-scientifico',
  templateUrl: './settore-scientifico.component.html',
  styleUrls: ['./settore-scientifico.component.css']
})
export class SettoreScientificoComponent implements OnInit {
  lstElenco: any;
  lstElencoPerUpdateFilter: any;
  txtFiltra: string = '';

  constructor(private srvUtilita: UtilitaService,
    private authService: AuthService,
    private dialog: MatDialog) { }

  ngOnInit(): void {
    this.getLista();
  }

  getLista() {
    this.srvUtilita.getLista('Utenti/GetSettoreScientificoLista').subscribe((res: any) => {
      this.lstElenco = res
      this.lstElencoPerUpdateFilter = res;
     // console.log('res', res)
    })
  }

  btnAggiungiModifica(iValore: number) {
    // console.log('ivalore', iValore)
    let dialogRef: MatDialogRef<any> = this.dialog.open(SettoreScientificoDettaglioComponent, {
      width: '720px',
      disableClose: false,
      data: { iValore: iValore }
    })
    dialogRef.afterClosed()
      .subscribe((res: any) => {
        this.txtFiltra = '';
        this.getLista();
      })
  }

  updateFilter(event: any) {
    const val = event.target.value.toLowerCase()
    const columns = Object.keys(this.lstElencoPerUpdateFilter[0])
    columns.splice(columns.length - 1)
    if (!columns.length) {
      return
    }
    this.lstElenco = this.lstElencoPerUpdateFilter;
    const rows = this.lstElenco.filter(function (d: any) {
      for (let i = 0; i <= columns.length; i++) {
        const column = columns[i]
        if (d[column] && d[column].toString().toLowerCase().indexOf(val) > -1) {
          return true
        }
      }
    })
    this.lstElenco = rows
  }

}
